/**
 * Checks is number
 *
 * @returns {boolean}
 */
const isNumber = () => typeof value === 'number';
export default isNumber;
